<template>
  <div class="card-header  border-0">
    <h5 class="card-title font-bold">
      جزئیات سفارش
    </h5>
    <div style="flex:1"></div>
    <button data-toggle="modal" v-if="admin.id == 1" data-target="#refund-modal" type="button" 
          class="btn btn-danger ml-2 btn-print">
      مرجوعی
    </button>
    <button data-toggle="modal"@click="refundPost" type="button" 
          class="btn btn-warning ml-2">
      مرجوعی پستی
    </button>
    <!-- <span v-if="showRefund && $route.query.developer_mode" id="refund">
      <button @click="refundOrder()" class="btn btn-danger ml-2 btn-print">
        مرجوعی دستی
      </button>
    </span> -->

    <span v-if="!order.reserved_id" id="order-edit">
      <button @click="orderEdit()" class="btn btn-info ml-2 btn-print">
        <i class="fe fe-edit"></i>
      </button>
    </span>
    <b-tooltip target="order-edit" triggers="hover">
      ویرایش سفارش
    </b-tooltip>

    <span v-if="!order.reserved_id" id="order-print">
      <button @click="printOrder()" class="btn btn-info ml-2 btn-print">
        <i class="fe fe-printer"></i>
      </button>
    </span>
    <b-tooltip target="order-print" triggers="hover">
      چاپ
    </b-tooltip>
    <Back />

     <div class="modal fade" id="refund-modal" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-content-demo">
          <div class="modal-header">
              <p class="modal-title font-weight-bold">مرجوع کردن سفارش</p>
              <button aria-label="Close" class="close" data-dismiss="modal"><span
                      aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body">
            <div class="row p-4">
              <div class="col-12 form-group">  
                <label>کد رهگیری:</label>  
                <input type="text" class="form-control" v-model="trackingCode">
              </div>  
              <div class="col-12 form-group">  
                <label>مبلغ(تومان):</label>  
                <b-form-input
                  :value="amount | priceinput"
                  @input="
                    (value) => {
                      amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>  
              <div class="col-12 form-group">  
                <label>رمز:</label>  
                <input type="password" class="form-control" v-model="password">
              </div>  
              <div class="col-12 form-group">  
                <label>نوع پرداخت:</label>  
                <select v-model="type" class="form-control" required>
                  <option selected disabled>-- انتخاب کنید --</option>
                  <option :value="11">کیف پول</option>
                  <option :value="13">درگاه</option>
                </select>
              </div>  
            </div>
            <div class="modal-footer justify-content-center">  
              <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>  
              <button type="submit" class="btn btn-primary" @click="submitData">مرجوع کردن</button>  
            </div>    
          </div>  
        </div>  
      </div>  
    </div>  

  </div>
</template>

<script>
import OrderHeaderImpl from "@@/core/components/order/OrderHeader/OrderHeaderImpl";

export default {
  extends: OrderHeaderImpl,
};
</script>

<style scoped></style>
